import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_product_comparison_table = _resolveComponent("product-comparison-table")
  const _component_modal_box = _resolveComponent("modal-box")
  const _component_progress_overlay = _resolveComponent("progress-overlay")

  return (_openBlock(), _createElementBlock("div", null, [
    ($options.hasData)
      ? (_openBlock(), _createBlock(_component_modal_box, {
          key: 0,
          "is-visible": "",
          width: $options.modalWidth,
          "show-action-close": true,
          onActionClose: $options.close
        }, {
          default: _withCtx(() => [
            _createVNode(_component_product_comparison_table, {
              "columns-data": _ctx.columnsData,
              "rows-data": _ctx.rowsData
            }, null, 8 /* PROPS */, ["columns-data", "rows-data"])
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["width", "onActionClose"]))
      : (_openBlock(), _createBlock(_component_progress_overlay, {
          key: 1,
          visible: !$options.hasData
        }, null, 8 /* PROPS */, ["visible"]))
  ]))
}